// extracted by mini-css-extract-plugin
export default {"innerWrapper":"nx-z","tooltipWrapper":"ox-z","icon":"px-z","tooltip":"qx-z","content":"rx-z"};